import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.css'],
    standalone: false
})
export class TaskComponent {
  @Input() size = 24;
  @Input() color = '#000';
}
